module.exports = __webpack_public_path__ + "static/media/dawghawtdawg-iphonex-enter-score.3746af41.jpg";